import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { PageHeader } from '../../components/shared/index';
import { useAuth } from '../../context/AuthContext';
import clsx from 'clsx';
import {
  BookOpenIcon,
  Squares2X2Icon,
  MapIcon,
  SparklesIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/outline';

import MyLearning          from './MyLearning';
import CourseCatalog       from './CourseCatalog';
import LearningPaths       from './LearningPaths';
import IdpPage             from './IdpPage';
import MandatoryCompliance from './MandatoryCompliance';

export default function Learning() {
  const { user }          = useAuth();
  const { tab: urlTab }   = useParams();
  const navigate          = useNavigate();
  const isHr              = ['hr_admin','super_admin'].includes(user?.role);

  const TABS = [
    { key: 'mine',      label: 'My Learning',     icon: BookOpenIcon,    component: MyLearning },
    { key: 'catalog',   label: 'Course Catalog',  icon: Squares2X2Icon,  component: CourseCatalog },
    { key: 'paths',     label: 'Learning Paths',  icon: MapIcon,         component: LearningPaths },
    { key: 'idp',       label: 'IDP',             icon: SparklesIcon,    component: IdpPage },
    ...(isHr ? [{ key: 'mandatory', label: 'Mandatory Compliance', icon: ShieldCheckIcon, component: MandatoryCompliance }] : []),
  ];

  const validKeys = TABS.map(t => t.key);
  const initial   = validKeys.includes(urlTab) ? urlTab : 'mine';
  const [tab, setTab] = useState(initial);

  useEffect(() => {
    if (urlTab && validKeys.includes(urlTab) && urlTab !== tab) setTab(urlTab);
  }, [urlTab]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectTab = (key) => {
    setTab(key);
    navigate(`/app/learning/${key}`, { replace: true });
  };

  const Active = TABS.find(t => t.key === tab)?.component ?? MyLearning;

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <PageHeader
        title="Learning & Development"
        subtitle="Grow skills aligned to your role, band, and individual development plan"
      />

      <div className="flex gap-1 mb-6 border-b border-gray-200 overflow-x-auto">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            onClick={() => selectTab(key)}
            className={clsx(
              'flex items-center gap-2 px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap',
              tab === key
                ? 'border-blue-600 text-blue-600'
                : 'border-transparent text-gray-500 hover:text-gray-700'
            )}
          >
            <Icon className="w-4 h-4" />
            {label}
          </button>
        ))}
      </div>

      <Active />
    </div>
  );
}
